import {QueryCacheKeys} from '../../api/cache';
import {getProjects} from '../../api/projects';
import Layout from '../Layout';
import ProjectsTable from './ProjectsTable';
import {Button, Icon} from '@sproutsocial/racine';
import {useQuery} from '@tanstack/react-query';

const ProjectList = () => {
	const {data: projects} = useQuery({
		queryKey: QueryCacheKeys.projects(),
		queryFn: () => getProjects(),
	});

	return (
		<Layout>
			<Layout.Header title='Projects'>
				<Button appearance='primary' href='/projects/new'>
					<Icon name='plus' mr='space.300' />
					New Project
				</Button>
			</Layout.Header>
			<Layout.Body>
				<ProjectsTable projects={projects ?? []} showProfit />
			</Layout.Body>
		</Layout>
	);
};

export default ProjectList;
